<script setup>
defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  columns: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <ul
    class="m-0 p-0 details-list__items"
    :class="[`details-list__items--${columns}`]"
  >
    <template v-for="(group, groupIndex) in data" :key="groupIndex">
      <li
        v-for="(groupItem, groupItemIndex) in group.items"
        :key="groupItemIndex"
        class="m-0 details-list__item"
        :class="`details-list__item--${groupIndex}`"
        data-aos="fade-up"
        :data-aos-delay="groupItemIndex >= 1 ? 100 + 100 * groupItemIndex : 100"
      >
        <span>
          <CIcon
            name="check-big-red"
            width="16"
            height="16"
            class="details-list__icon"
            aria-hidden="true"
          />
        </span>
        <span class="details-list__text" v-html="groupItem.title"></span>
      </li>
    </template>
  </ul>
</template>

<style scoped lang="scss">
$groups: 10;
.details-list {
  $parent: &;
  &__items {
    list-style: none;
    @include media-breakpoint-up(sm) {
      column-count: 2;
      gap: 80px;
      position: relative;
      &::before {
        content: '';
        background-color: $divider;
        height: calc(100% - 24px);
        left: 50%;
        position: absolute;
        top: 0;
        width: 1px;
      }
    }
    @include media-breakpoint-up(md) {
      column-count: 3;
      gap: 40px;
      &::before {
        left: calc(33.33% - 27px);
      }
      &::after {
        content: '';
        background-color: $divider;
        height: calc(100% - 24px);
        left: calc(66.66% - 13px);
        position: absolute;
        top: 0;
        width: 1px;
      }
      &--2 {
        column-count: 2;
        &::before {
          left: calc(50% - 20px);
        }
        &::after {
          display: none;
        }
      }
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 40);
      &::before {
        left: calc(33.33% - px-to-vw(27));
        @include responsive-spacing(width, 1);
      }
      &::after {
        height: calc(100% - px-to-vw(24));
        left: calc(66.66% - px-to-vw(13));
        @include responsive-spacing(width, 1);
      }
      &--2 {
        column-count: 2;
        &::before {
          left: calc(50% - px-to-vw(20));
        }
        &::after {
          display: none;
        }
      }
    }
  }
  &__item {
    @include body-3-bold;
    display: grid;
    grid-template-columns: 16px auto;
    gap: 8px;
    padding-bottom: 16px;
    @include media-breakpoint-up(sm) {
      break-inside: avoid;
      padding-bottom: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
      @include responsive-spacing(padding-bottom, 24);
      grid-template-columns: px-to-vw(16) auto;
    }
  }
  &__icon {
    margin-top: 3px;
    height: auto;
    width: 100%;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(margin-top, 3);
    }
  }
}
@for $i from 1 through $groups {
  .details-list__item--#{$i}:not(
      .details-list__item--#{$i} ~ .details-list__item--#{$i}
    ) {
    border-top: 1px solid $divider;
    margin-top: 8px;
    padding-top: 24px;
    @include media-breakpoint-up(sm) {
      border-top: unset;
      margin-top: 0px;
      padding-top: 0px;
    }
    @include media-breakpoint-up(md) {
      break-before: column;
      -webkit-column-break-before: always;
    }
  }
}
</style>
